export default class {
  constructor (content) {
    this.id = content.id
    this.title = content.title
    this.description = content.description
    this.thumbnail = content.thumbnail
    this.images = content.images
    this.newdetail1 = content.newdetail1
    this.newdetail2 = content.newdetail2
    this.newdetail3 = content.newdetail3
    this.newdetail = content.newdetail
    this.pagenumbs = content.pagenumbs
    this.requiredBasicFields = content.requiredBasicFields || ['all']
    this.hashs = content.hashs || []
    this.components = content.components || {}
    this.cards = content.cards || []
    this.sampleData = content.sampleData || {}
    this.exampleSentences = content.exampleSentences || {}
    this.formatDataType = content.formatDataType
  }
}
